import { appBarMeta } from "@constants/appbar";
import { events } from "@constants/tracking";
import ChallengeProgressContainer from "@features/dashboard/containers/ChallengeProgressContainer";
import ProgressContainer from "@features/dashboard/containers/ProgressContainer";
/* -----------------Features--------------- */
import { useAppStore } from "@hooks/useAppStore";
import CustomAppBar from "@memorang/ui/components/CustomAppbar";
import { trackCustomEvent } from "analytics";
import DocumentTitle from "components/DocumentTitle";
import { useNavigation } from "expo-router";
import { useTranslation } from "react-i18next";

const ProgressRoute = () => {
	const { t } = useTranslation();
	const navigation = useNavigation<{ toggleDrawer?: () => void }>();
	const isImageChallengeApp = useAppStore(
		(state) => state.app.isImageChallengeApp,
	);

	return (
		<>
			<DocumentTitle title={isImageChallengeApp ? "Insights" : "Progress"} />
			<CustomAppBar
				title={isImageChallengeApp ? "Insights" : t(appBarMeta.progress.title)}
				navigation={navigation}
				handleTrackEvent={() => {
					trackCustomEvent({
						eventName: events.commandBarClicked,
						option: "command_bar",
					});
				}}
			/>
			{isImageChallengeApp ? (
				<ChallengeProgressContainer />
			) : (
				<ProgressContainer />
			)}
		</>
	);
};

export default ProgressRoute;
